<section>
  <div class="card mb-3">
    <div #tgt id="filterBody" class="card-body p-2">
      <ness-geographic-filter #gf [geoFilterVerbiage]="'Filter by geographic region:'" (isLoading)="loading = $event" [geoFilterStorageKey]="geoFilterStorageKey"></ness-geographic-filter>
      <div class="ms-sm-auto px-sm-3 py-2 px-md-4">
        <input class="form-check-input" type="checkbox" name="showOnlyOrphan" id="showOnlyOrphan" [(ngModel)]="showOnlyOrphan">
        <span class="ms-2">Only Orphan Agency Records</span>
        <span class="ms-2 fst-italic">(Checking this box ignores filters above)</span>
      </div>
      <div class="ms-sm-auto px-sm-3 py-2 px-md-4">
        <button type="button" class="btn btn-success mb-2 me-sm-2" [disabled]="loading" [attr.aria-disabled]="loading" (click)="applyFilters()" title="Apply filters">Apply<span class="visually-hidden"> filters</span></button>
        <button type="button" class="btn btn-secondary mb-2 me-sm-2" [disabled]="loading" [attr.aria-disabled]="loading" (click)="resetDefaultFilters()" title="Reset filters to defaults">Reset<span class="visually-hidden"> filters to defaults</span></button>
      </div>
    </div>
  </div>
  <div class="alert alert-info d-flex flex-column justify-content-evenly" role="alert">
    <div>
      <small><i aria-hidden="true" class="text-danger fas fa-exclamation-triangle fa-1x me-2"></i>
      <strong class="text-danger">REMINDER: Changed agency info?</strong> Update the user/event import templates, if applicable and then upload.</small>
    </div>
    <div>
      <small><i aria-hidden="true" class="fas fa-info-circle fa-1x me-2"></i> Once changes are committed, the  <strong>updates will be reflected in NESS automatically</strong> (no coordination with DBA or software release is required).</small>
    </div>
  </div>
  <h2 class="h4">Manage Agencies</h2>
  <p-messages key="manageAgenciesMsg" [closable]="true"></p-messages>
  <p-confirmDialog [breakpoints]="{'992px': '35vw', '576px': '70vw'}" [style]="{width: '35vw'}"></p-confirmDialog>
  <p-table #agencydt [value]="agencies" [columns]="cols" dataKey="AgencyID" editMode="row" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" sortMode="multiple" responsiveLayout="scroll" (sortFunction)="sortMultipleAgency($event)" [customSort]="true " [autoLayout]="true" [(selection)]="selectedAgencies" [globalFilterFields]="['AgencyName', 'ENESS_XREF_AgencyOriNum.OriNum', 'FieldDivisionName', 'ENESS_XREF_AgencyFieldDivisionGroups.GroupName', 'StateName', 'CountyName']" (onFilter)="filterGlobalAgency($event)">
    <ng-template pTemplate="caption">
      <div class="visually-hidden">Editable list of NESS agencies</div>
      <div class="d-flex flex-wrap p-2 filter-status">
        <button type="button" class="btn btn-success me-2 mb-2" (click)="addAgencyRow(filterInput)">Add agency</button>
        <button type="button" class="btn btn-success me-2 mb-2" [disabled]="selectedAgencies.length != 2" (click)="mergeAgencies(filterInput)">Merge selected agencies</button>
		    <button type="button" class="btn btn-success me-2 mb-2" (click)="exportCdsData(filterInput)">CDS Data Export</button>
        <div class="ms-lg-auto">
          <div class="input-group">
            <span class="input-group-text" aria-hidden="true"><i class="fa fa-search"></i></span>
            <input #filterInput pInputText  type="text" placeholder="Agencies Filter" aria-label="Filter agencies table by agency name, ORI number, field division, field division group, state or county value." class="form-control" (input)="globalFilterChanged($any($event.target).value)">
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" style="width: 4em">Merge</th>
        <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{ col.header }} <p-sortIcon title="Press Ctrl-Key on click to sort on multiple columns." [field]="col.field" ariaLabel="Activate to sort. To sort on multiple columns, use control key when clicking on more than one column." ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th scope="col">Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="rowData" [class.align-top]="editing">
        <td class="text-center">
          <p-tableCheckbox [value]="rowData" [disabled]="disableMergeCheckbox(rowData)" aria-label="Select this agency to merge"></p-tableCheckbox>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="rowData.AgencyName" id="AgencyName" name="AgencyName" #AgencyName="ngModel" required>
              <div class="invalid-feedback" *ngIf="AgencyName.invalid" role="alert">
                Please enter the agency name.
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              {{rowData.AgencyName}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <div class="d-flex justify-content-center">
            <ng-container>
              <a  aria-label="'Agency '+rowData.CDS+'  details'" (click)="viewCDSDetails(rowData)">
                  <ng-container *ngIf="rowData.MOU && rowData.CDS && !!rowData.CDSApproverID?.length then mouCdsApproverValue; else ifElseIf;"></ng-container>
				          <ng-template #ifElseIf>
                    <ng-container *ngIf="rowData.MOU && rowData.CDS then cdsValue; else elseIf;"></ng-container>
                  </ng-template>
				          <ng-template #elseIf>
                    <ng-container *ngIf="rowData.MOU then mouValue; else defaultValue;"></ng-container>
                  </ng-template>
                  <ng-template #mouValue>MOU</ng-template>
                  <ng-template #cdsValue>MOU/CDS</ng-template>
				          <ng-template #mouCdsApproverValue>MOU/CDS/CDS Approver</ng-template>
                  <ng-template #defaultValue>None</ng-template>
              </a>
            </ng-container>
            </div>
        </td>
        <td>
          <ng-container *ngFor="let oriNum of rowData.ENESS_XREF_AgencyOriNum; let i=index; let last=last; let first=first">
              <p-cellEditor>
                <ng-template pTemplate="input">
                    <div class="d-inline-flex align-items-center">
                      <input pInputText type="text" [(ngModel)]="oriNum.OriNum" id="{{oriNum.OriNum}}" name="{{oriNum.OriNum}}" class="me-2 mb-1" #OriNum="ngModel" required>
                      <button aria-label="Delete ORI Number" pButton type="button" pInitEditableRow icon="pi pi-times" class="p-button-danger me-2 mb-1" (click)="deleteNewORINumberRow(rowData, i)" title="Delete ORI Number" *ngIf="!first && oriNum.AgencyOriNumID == null "> </button>
                      <button aria-label="Add ORI Number" pButton type="button" pInitEditableRow icon="pi pi-plus" class="p-button-success me-2 mb-1" (click)="addNewORINumberRow(rowData)" title="Add ORI Number" *ngIf="last"> </button>
                    </div>
                    <div class="cross-validation-feedback" *ngIf="OriNum.invalid" role="alert">
                      Please enter the ORI number.
                    </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="my-1">{{rowData.ENESS_XREF_AgencyOriNum[i].OriNum}}</div>
                </ng-template>
              </p-cellEditor>
          </ng-container>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <select [(ngModel)]="rowData.FieldDivisionID" id="FieldDivisions" name="FieldDivisions" #FieldDivisions="ngModel" aria-label="Select the agency's field division." aria-required="true" [attr.aria-invalid]="!rowData.FieldDivisionID" class="form-select w-auto" (change)="onSelectFieldDivision(rowData)" required>
                <option value="">Select a field division</option>
                <ng-container *ngIf="fieldDivisions$ | async as fieldDivisions">
                  <option *ngFor="let fieldDiv of fieldDivisions" value="{{fieldDiv.FieldDivisionID}}">{{fieldDiv.FieldDivisionName}}</option>
                </ng-container>
              </select>
              <div class="invalid-feedback" *ngIf="FieldDivisions.invalid" role="alert">
                Please select a field division.
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              {{rowData.FieldDivisionName}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <ng-container *ngFor="let fdGroup of rowData.ENESS_XREF_AgencyFieldDivisionGroups; let i=index; let last=last; let first=first">
              <p-cellEditor>
                <ng-template pTemplate="input">
                    <div class="d-inline-flex align-items-center">
                      <select [(ngModel)]="fdGroup.IntelligenceReportATFReferralGroupsID" id="{{fdGroup.AgencyFieldDivisionGroupID}}" name="{{fdGroup.AgencyFieldDivisionGroupID}}" #FieldDivisionGroup="ngModel" aria-label="Select the agency's field division group." aria-required="true" [attr.aria-invalid]="!fdGroup.IntelligenceReportATFReferralGroupsID" class="form-select w-auto me-2 mb-1" [disabled]="!rowData.FieldDivisionID" (change)="updateFieldDivisionGroupRow(fdGroup, FieldDivisionGroup.value)" required>
                        <option value="">Select a group</option>
                        <ng-container *ngIf="fieldDivisionGroups$ | async as fieldDivisionGroups">
                          <option *ngFor="let group of activeFieldDivisionGroups[rowData.AgencyID]" value="{{group.IntelligenceReportATFReferralGroupsID}}">{{group.GroupName}}</option>
                        </ng-container>
                      </select>
                      <button aria-label="Delete field division group" pButton type="button" pInitEditableRow icon="pi pi-times" class="p-button-danger me-2 mb-1" (click)="deleteNewFieldDivisionGroupRow(rowData, i)" title="Delete field division group" *ngIf="rowData.ENESS_XREF_AgencyFieldDivisionGroups.length > 1"> </button>
                      <button aria-label="Add field division group" pButton type="button" pInitEditableRow icon="pi pi-plus" class="p-button-success me-2 mb-1" (click)="addNewFieldDivisionGroupRow(rowData)" title="Add field division group" *ngIf="last"> </button>
                    </div>
                    <div class="cross-validation-feedback" *ngIf="FieldDivisionGroup.invalid" role="alert">
                      Please select a field division group.
                    </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="mb-1 text-nowrap">{{rowData.ENESS_XREF_AgencyFieldDivisionGroups[i]?.GroupName}}</div>
                </ng-template>
              </p-cellEditor>
          </ng-container>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <select [(ngModel)]="rowData.StateID" id="States" name="States" #States="ngModel" aria-label="Select the agency's state." aria-required="true" [attr.aria-invalid]="!rowData.StateID" class="form-select w-auto" (change)="onSelectState(rowData)" [disabled]="!rowData.FieldDivisionID" required>
                <option value="">Select a state</option>
                <ng-container *ngIf="states$ | async as states">
                  <option *ngFor="let state of activeStates[rowData.AgencyID]" value="{{state.StateID}}">{{state.StateName}}</option>
                </ng-container>
              </select>
              <div class="invalid-feedback" *ngIf="States.invalid" role="alert">
                Please select a state.
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              {{rowData.StateName}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <select [(ngModel)]="rowData.CountyID" id="Counties" name="Counties" #Counties="ngModel" aria-label="Select the agency's county." aria-required="true" [attr.aria-invalid]="!rowData.CountyID" class="form-select w-auto" [disabled]="!rowData.StateID" required>
                <option value="">Select a county</option>
                <ng-container *ngIf="counties$ | async as counties">
                  <option *ngFor="let county of activeCounties[rowData.AgencyID]" value="{{county.CountyID}}">{{county.CountyName}}</option>
                </ng-container>
              </select>
              <div class="invalid-feedback" *ngIf="Counties.invalid" role="alert">
                Please select a county.
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              {{rowData.CountyName}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <div class="d-flex justify-content-center">
            <button *ngIf="!editing" aria-label="Edit agency row" pButton type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-info" (click)="onRowEditInit(rowData)" title="Edit agency row"></button>
            <button *ngIf="editing" aria-label="Save agency changes" pButton type="button" pSaveEditableRow icon="pi pi-check" class="p-button-success me-2" (click)="onRowEditSave(rowData, ri)" [disabled]="disableSaveAgency(rowData)" title="Save agency changes"></button>
            <button *ngIf="editing" aria-label="Cancel agency changes" pButton type="button" pCancelEditableRow icon="pi pi-times" class="p-button-danger" (click)="onRowEditCancel(rowData, ri)" title="Cancel agency changes"></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 2">
          No agencies found.
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
<aside *ngIf="displaySidebar">
  <p-sidebar [(visible)]="displaySidebar" (onShow)="onShowSidebar()" (onHide)="onHideSidebar()" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
    <ng-container *ngIf="openMergeAgenciesForm">
      <ness-merge-agencies [selectedAgencies]="selectedAgencies" (closeMergeForm)="onHideSidebar()" (onMerge)="mergeCompleted()"></ness-merge-agencies>
    </ng-container>
    <ng-container *ngIf="openMouCdsForm">
      <ness-agency-mou-cds-form [selectedAgency]="agency" (closeMouCdsForm)="onHideSidebar()" (onSave)="onMouCdsSave()"></ness-agency-mou-cds-form>
    </ng-container>
  </p-sidebar>
</aside>
